import { Close } from "@payping/icons";
import { Trans } from "@payping/utils/localeUtils";
import { webConstants } from "@payping/utils/platformConstants";
import { Button, Collapse, Typography } from "@payping/web-components";
import classNames from "classnames";
import { useLocation } from "react-router-dom";
import React, { ReactElement, useEffect, useState } from "react";

import styles from "../../assets/scss/Help.module.scss";
import { useAppTranslation } from "../../utils/useAppTranslation";
import { FAQ, FAQType } from "./data";

const Help: React.FC = () => {
  const [currHelpData, setCurrHelpData] = useState<FAQType[]>([]);
  const { t } = useAppTranslation();
  const location = useLocation();
  const donateScriptRoute = webConstants.DashboardRoutes.ipg.service.detail.replace(":name", "donateScript");

  useEffect(() => {
    setCurrHelpData([]);
    Object.values(FAQ).forEach((data) => {
      data.url.forEach((url) => {
        if (location.pathname.startsWith(url) && !location.pathname.includes(donateScriptRoute)) {
          setCurrHelpData((prev: any) => [...prev, data]);
        }
      });
    });
  }, [donateScriptRoute, location]);

  const currSection = location.pathname.split("/")[1] || "report";
  const [visible, setVisible] = useState<boolean>(false);

  const translationComponents: Record<string, ReactElement> = {
    a: <a />,
    bold: <strong />,
    link: <Typography.Link />,
    p: <Typography.Paragraph />,
    span: <Typography.Text style={{ display: "block" }} />,
  };

  return currHelpData.length ? (
    <div className={styles.helpWrapper}>
      <div className={classNames(styles.collapseWrapper, visible ? "" : styles.hiddenHelp)}>
        <div className={styles.helpTitle}>
          <span>{t(`help.buttonTitle.${currSection}`)}</span>
          <Close className={styles.closeButton} width={"14px"} onClick={() => setVisible(false)} />
        </div>
        <div className={styles.collapseScroll}>
          <Collapse accordion>
            {currHelpData.map((faq, index: number) => (
              <Collapse.Panel header={t(`help.guide.${faq.translationKey}.q`)} key={index}>
                <Typography.Paragraph>
                  <Trans components={translationComponents} i18nKey={t(`help.guide.${faq.translationKey}.a`)} />
                </Typography.Paragraph>
              </Collapse.Panel>
            ))}
          </Collapse>
        </div>
      </div>

      <Button
        size={"small"}
        variant={"primary"}
        className={classNames(styles.helpButton, visible ? styles.active : "")}
        onClick={() => setVisible((prev) => !prev)}
      >
        {t(`help.buttonTitle.${currSection}`)}
      </Button>
    </div>
  ) : null;
};

export default Help;
